module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('h1', [_vm._v("Werkstattaufträge")]), _vm._v(" "), _c('p', [_vm._v("Hier sehen Sie, welche Geräte Sie bei uns in der Werkstatt hatten.")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.serviceorders,
      "pagination": _vm.pagination,
      "rows-per-page-text": 'Aufträge pro Seite',
      "no-data-text": 'Keine Aufträge vorhanden'
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.moment(props.item.order_date).format('L')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.device))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.accessoires))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.state))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [(props.item.invoice) ? _c('a', {
          on: {
            "click": function($event) {
              _vm.invoiceDownload(props.item.invoice.invoice_id)
            }
          }
        }, [_vm._v("herunterladen")]) : _vm._e()])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43708563","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/ServiceOrderOverview.vue
// module id = 584
// module chunks = 1